var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex justify-content-center no-data"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/media/images/logo/logo.png"),"alt":""}})])
}]

export { render, staticRenderFns }